import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=39b272d8&scoped=true&"
import script from "./PrivacyNotice.vue?vue&type=script&lang=js&"
export * from "./PrivacyNotice.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyNotice.vue?vue&type=style&index=0&id=39b272d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b272d8",
  null
  
)

export default component.exports